<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="用户名称">
        <el-input v-model="dataForm.username" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item label="openid" prop="openid">
        <el-input v-model="dataForm.openid" placeholder="用户的openid"></el-input>
      </el-form-item>
      <el-form-item label="发送模板" prop="templateCode">
        <el-input v-model="dataForm.templateCode" placeholder="发送模板"></el-input>
      </el-form-item>
      <el-form-item label="详情地址">
        <el-input v-model="dataForm.url" placeholder="发送模板"></el-input>
      </el-form-item>
      <el-form-item label="发送类型" prop="type">
        <el-select v-model="dataForm.type" clearable placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发送状态" prop="status">
        <el-select v-model="dataForm.status" clearable placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="返回码">
        <el-input v-model="dataForm.responseCode" placeholder="返回码"></el-input>
      </el-form-item>
      <el-form-item label="发送内容" prop="content">
        <el-input type="textarea" v-model="dataForm.content" placeholder="发送内容"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      typeOptions: [],
      statusOptions: [],
      dataForm: {
        id: 0,
        openid: '',
        content: '',
        responseCode: '',
        status: '',
        type: '',
        templateCode: '',
      },
      dataRule: {
        openid: [
          {required: true, message: 'openid不能为空', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '发送内容不能为空', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '状态不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '短信类型不能为空', trigger: 'blur'}
        ],
        templateCode: [
          {required: true, message: '模板ID不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  created() {
    this.getTypeOption()
    this.getStatusOption()
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl("/wechatMsg/list/"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/wechatMsg/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'openid': this.dataForm.openid,
              'username': this.dataForm.username,
              'content': this.dataForm.content,
              'responseCode': this.dataForm.responseCode,
              'status': this.dataForm.status,
              'type': this.dataForm.type,
              'templateCode': this.dataForm.templateCode,
              'url': this.dataForm.url,
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取类型
    getTypeOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/12"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.typeOptions = data.data.enumOption
        }
      })
    },
    //获取状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/8"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.statusOptions = data.data.enumOption
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/wechatMsg-add-or-update.vue